module.exports = __webpack_public_path__ + "img/bigData.2166d631.png";